import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../common/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ServiceModule } from '../service/service.module';
import { NetzzuordnungenListComponent } from './netzzuordnungen-list/netzzuordnungen-list.component';
import { NetzzuordnungenPageComponent } from './netzzuordnungen-page/netzzuordnungen-page.component';
import { NetzzuordnungenTableComponent } from './netzzuordnungen-table/netzzuordnungen-table.component';
import { NetzzuordnungenFilterComponent } from './netzzuordnungen-filter/netzzuordnungen-filter.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NetzzuordnungenRoutingModule } from './netzzuordnungen-routing.module';

@NgModule({ declarations: [
    NetzzuordnungenListComponent,
    NetzzuordnungenPageComponent,
    NetzzuordnungenTableComponent,
    NetzzuordnungenFilterComponent,
], imports: [
    CommonModule,
    MaterialModule,
    ServiceModule,
    NetzzuordnungenRoutingModule,
    FormsModule,
    ReactiveFormsModule,
], providers: [
    provideHttpClient(withInterceptorsFromDi()),
] })
export class NetzzuordnungenModule {
}
